import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './App.module.css';
import InputForm from '../components/Form/InputForm';
import Results from '../components/Results/Results';
import useCalculator from '../hooks/useCalculator';
import ReactGA from "react-ga4";


function LifeInsurance() {
  ReactGA.initialize("G-1HWZHF4TVV");
  ReactGA.gtag("event", "conversion", {
    send_to: "AW-780199100/2Dg_CN3xsY8cELzJg_QC",
  });
  const [showResults, setShowResults] = useState(false);
  const { calculationData, calculateNeeds, resetCalculator } = useCalculator();

  const handleCalculate = (formData) => {
    const results = calculateNeeds(formData);
    setShowResults(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleReset = () => {
    resetCalculator();
    setShowResults(false);
  };

  return (
    <div className={styles.app}>
      <header className={styles.header}>
        <div className={styles.container}>
          <h1>
            <span className={styles.logo}>Grow Idea Financial</span>
          </h1>
          <p className={styles.tagline}>
            Kalkulator Kebutuhan Asuransi Jiwa - Hitung Proteksi yang Tepat untuk Keluarga Tercinta
          </p>
        </div>
      </header>

      <main className={styles.main}>
        <div className={styles.container}>
          {!showResults ? (
            <InputForm onCalculate={handleCalculate} />
          ) : (
            <Results data={calculationData} onReset={handleReset} />
          )}
        </div>
      </main>

      <footer className={styles.footer}>
        <div className={styles.container}>
          <p>© 2024 Grow Idea Financial. All rights reserved.</p>
          <p className={styles.disclaimer}>
            *Hasil kalkulasi bersifat estimasi. Konsultasikan dengan perencana keuangan profesional untuk analisis lebih detail.
          </p>
        </div>
      </footer>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
}

export default LifeInsurance;